/**
 * Customized global styles.
 *
 * Reference: https://chakra-ui.com/docs/theming/customize-theme
 */

const styles = {
  global: {
    body: {
      color: 'greyScale.900',
      textStyle: 'bodyLg',
      letterSpacing: '-0.02em'
    },
    button: { textStyle: 'button' },
    ol: { listStyle: 'decimal inside' },
    ul: { listStyle: 'disc inside' },
    p: { my: 0 }
  }
};

export default styles;
